import axios from "axios";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";
import { useNavigate } from "react-router-dom";

export default function DeliveryTimes() {
  const [formData, setFormData] = useState({
    morningShiftTime: "",
    eveningShiftTime: "",
    gapHours: "",
  });

  const navigate=useNavigate();
  const [disableBtn, setDisableBtn] = useState(false);

  useEffect(() => {
    getDeliveryTimes();
  }, []);

  const getDeliveryTimes = async () => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/delivery-time/get-delivery-time`,
        { headers }
      );

      if (response.data.statusCode === 200) {
        const data = response.data.result.data;
        setFormData({
          morningShiftTime: data.pickupTime?.[0] || "",
          eveningShiftTime: data.deliveryTime?.[0] || "",
          gapHours: data.gapHours || ""
        });
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };

      const formdata = new FormData();
      formdata.append("pickupTime", formData.morningShiftTime);
      formdata.append("deliveryTime", formData.eveningShiftTime);
      formdata.append("gapHours", formData.gapHours);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/delivery-time/save`,
        formdata,
        { headers }
      );

      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getDeliveryTimes(); // refresh after update
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update delivery time.");
    }
    setDisableBtn(false);
  };

  return (
    <Layout>
      <ToastContainer />
      <div>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">Update Delivery Times</h2>

            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>

          </div>
          <div className="mt-10" onSubmit={handleSubmit}>
            <form>
              <div className="mb-6">
                <label className="text-sm">Pickup Time</label>
                <input
                  type="text"
                  name="morningShiftTime"
                  className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm capitalize"
                  placeholder="Enter Pickup Time"
                  value={formData.morningShiftTime}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-6">
                <label className="text-sm">Delivery Time</label>
                <input
                  type="text"
                  name="eveningShiftTime"
                  className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm capitalize"
                  placeholder="Enter Delivery Time"
                  value={formData.eveningShiftTime}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-6">
                <label className="text-sm">Gap Hours</label>
                <input
                  type="number"
                  name="gapHours"
                  className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm text-sm"
                  placeholder="Enter Gap Hours"
                  value={formData.gapHours}
                  onChange={handleInputChange}
                  min="0"
                  required
                />
              </div>
              <div className="text-end">
                <button
                  type="submit"
                  disabled={disableBtn}
                  className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                >
                  {disableBtn ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
}
